import { render, staticRenderFns } from "./DisciplineSummaryBox.vue?vue&type=template&id=25feb268&scoped=true&"
import script from "./DisciplineSummaryBox.vue?vue&type=script&lang=js&"
export * from "./DisciplineSummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineSummaryBox.vue?vue&type=style&index=0&id=25feb268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25feb268",
  null
  
)

export default component.exports